import { APP_INITIALIZER, Injector } from '@angular/core';
import { combineLatest } from 'rxjs';
import { RoutesService } from '@abp/ng.core';
import { USER_ACTIONS_MANAGEMENT_ROUTE_VISIBILITY } from './features.token';
import { ProviderConsts } from 'src/app/shared/Constants/providers.constants';

export const USER_ACTIONS_MANAGEMENT_VISIBLE_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        useFactory: userActionsManagementVisibility,
        deps: [Injector],
        multi: true,
    },
];

export function userActionsManagementVisibility(injector: Injector) {
    return () => {
        const isUserActionsManagementFeatureEnable$ = injector.get(USER_ACTIONS_MANAGEMENT_ROUTE_VISIBILITY);
        const routes = injector.get(RoutesService);
        combineLatest([isUserActionsManagementFeatureEnable$]).subscribe(
        ([isUserActionsManagementFeatureEnable]) => {
            routes.patch(ProviderConsts.USER_ACTION_ROUTE_PATCH_NAME, {
                invisible: !isUserActionsManagementFeatureEnable,
            });
        },
        );
    };
}
